import { atom } from "recoil";

export const CharactersLenghtAtom = atom({
  key: "CharactersLenghtAtom",
  default: 0,
});
